import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withStyles } from "@material-ui/styles";
import continueBtnStyles from "./continueBtn.style";
import Grid from "@material-ui/core/Grid";
import T from "Translate";
import Fab from "@material-ui/core/Fab";
import ToggleDisplay from "Common/ToggleDisplay";
import MarketFeatureSvc from "Services/marketFeatures";

class ContinueBtn extends Component {
    displayContinueBtn() {
        let actionElementPos = { top: "" };
        let stickyElement = document.querySelector("#sticky");
        let checkMarks = document.querySelector("#checkMarks");
        if (!stickyElement && !checkMarks) {
            return;
        }
        if (checkMarks) {
            actionElementPos = ReactDOM.findDOMNode(document.querySelector("#checkMarks")).getBoundingClientRect();
        }
        if (window.innerHeight > actionElementPos.top + 50) {
            stickyElement.classList.add("sticky");
        } else {
            stickyElement.classList.remove("sticky");
        }
    }

    componentDidMount() {
        this.displayContinueBtn();
        window.addEventListener("scroll", this.displayContinueBtn, false);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.displayContinueBtn, false);
    }

    render() {
        const { classes, disabled, submitting } = this.props;
        return (
            <Grid item xs={12} id="sticky">
                <Grid item align="center">
                    <div className={classes.continuebtn}>
                        <Fab
                            variant="extended"
                            type="submit"
                            disabled={this.props.disabled || submitting}
                            data-testid="get_started"
                            id="form_join_submit"
                            onClick={this.props.handleSubmit}
                        >
                            {disabled || submitting ? <div className={classes.spinner} /> : <T>get_started</T>}
                        </Fab>
                    </div>
                    <ToggleDisplay if={MarketFeatureSvc.isEnabled("account_easy_enroll_shop")}>
                        <div className={classes.continuebtn}>
                            <Fab variant="extended" type="button" aria-label="Delete">
                                <T>Continue to Place First Order</T>
                            </Fab>
                        </div>
                        <div className={classes.orderlaterLink} onClick={this.props.handleSubmit}>
                            I am done for now, I will place my first order later
                        </div>
                    </ToggleDisplay>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(continueBtnStyles)(ContinueBtn);



// WEBPACK FOOTER //
// ./src/components/StartContainer/ContinueBtn/ContinueBtn.js